import { AppFactory, sessionManager } from 'vue-infra';
import { get, join, has } from 'lodash';
import { IHUB_SHELL_DOMAINS, IHUB_SHELL_PLATFORM_DOMAIN } from '@/common/consts';
import BaseService from '@/common/BaseService';
import ShellClient from '@/clients/ShellClient';
import ApiResources from '@/data/apiResources';
import transformer from './transformer';

const store = AppFactory.store;

class ShellService extends BaseService {
  constructor() {
    super({ name: 'ShellService' });
    this.shellClient = null;
  }

  async getShellItems() {
    const shellSettings = {
      method: ShellClient.HTTP_METHODS.GET,
    };
    try {
      if (!this.shellClient) {
        this.shellClient = createShellClient();
      }
      shellSettings.url = await getAPIUrl(['shell']);
      const response = await this.sendClientRequest({
        client: this.shellClient,
        settings: shellSettings,
        errorMsg: 'Couldn\'t fetch IHubShell Response',
      });
      return transformer.transformShellIHubResponse(response);
    } catch (error) {
      this.logError(`Error fetching shell items: ${error}`);
      return Promise.reject(error);
    }
  }

  async getShellPartners() {
    const shellSettings = {
      method: ShellClient.HTTP_METHODS.GET,
    };
    try {
      if (!this.shellClient) {
        this.shellClient = createShellClient();
      }
      shellSettings.url = await getAPIUrl(['partner']);
      const response = await this.sendClientRequest({
        client: this.shellClient,
        settings: shellSettings,
        errorMsg: 'Couldn\'t fetch Shell Partner Response',
      });
      return transformer.transformPartnersResponse(response);
    } catch (error) {
      this.logError(`Error fetching shell items: ${error}`);
      return Promise.reject(error);
    }
  }
}

function createShellClient() {
  return new ShellClient({
    resource: ShellClient.RESOURCES.SHELL_IHUB,
    contextName: 'GetShellInfo',
  });
}

async function getAPIUrl(suffixes = []) {
  const accountId = await store.getters['session/getValue']('accountId');
  let accountZone = sessionManager.getAccountZone();
  if (accountZone === 'qa' || !has(IHUB_SHELL_DOMAINS, accountZone)) {
    accountZone = 'z0';
  }
  const ihubPlatformDomain = IHUB_SHELL_DOMAINS[accountZone][IHUB_SHELL_PLATFORM_DOMAIN];
  const base = get(ApiResources, ShellClient.RESOURCES_CONFIGURATION[ShellClient.RESOURCES.SHELL_IHUB].URL_KEY()).url
    .replace('{AccountId}', accountId)
    .replace(`{${IHUB_SHELL_PLATFORM_DOMAIN}}`, `//${ihubPlatformDomain}`);
  if (suffixes.length) {
    return join([base, ...suffixes], '/');
  }
  return base;
}

const shellService = new ShellService();

export default shellService;
